// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ermlk","placeholdersHeader":"styles_placeholdersHeader__2BLtH","editorStyle":"styles_editorStyle__TIgsN","placeholdersBox":"styles_placeholdersBox__1lW5u"};